import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const GridSquaresIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect height="7" rx="1.5" stroke="currentColor" strokeWidth="2" width="7" x="3" y="3" />
    <rect height="7" rx="1.5" stroke="currentColor" strokeWidth="2" width="7" x="14" y="3" />
    <rect height="7" rx="1.5" stroke="currentColor" strokeWidth="2" width="7" x="3" y="14" />
    <rect height="7" rx="1.5" stroke="currentColor" strokeWidth="2" width="7" x="14" y="14" />
  </svg>
);

GridSquaresIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(GridSquaresIcon);
